// Legal-document loader.
//
// One file per (slug, locale) under `public/legal/<slug>.<locale>.md` —
// the user's current locale is fetched first, with Indonesian as the
// canonical fallback. CRA serves the `public/` tree verbatim, so the
// browser pulls the document at runtime via `fetch`. Each document is
// only fetched once per session thanks to the in-memory cache below.

export type LegalSlug = 'tnc-ppob'

const FALLBACK_LOCALE = 'id'

const cache = new Map<string, string>()

async function tryFetch(slug: LegalSlug, locale: string): Promise<string | null> {
  const key = `${slug}.${locale}`
  if (cache.has(key)) return cache.get(key) as string

  const url = `${process.env.PUBLIC_URL ?? ''}/legal/${key}.md`
  try {
    const res = await fetch(url)
    if (!res.ok) return null
    const text = await res.text()
    // CRA's history-mode fallback returns index.html (200) for missing
    // files. Detect that and treat as not-found so we move on to the
    // fallback locale rather than rendering a chunk of HTML.
    if (text.trim().startsWith('<')) return null
    cache.set(key, text)
    return text
  } catch {
    return null
  }
}

export async function loadLegalDoc(slug: LegalSlug, locale: string): Promise<string> {
  const candidates = locale === FALLBACK_LOCALE ? [locale] : [locale, FALLBACK_LOCALE]
  for (const l of candidates) {
    const text = await tryFetch(slug, l)
    if (text !== null) return text
  }
  return ''
}
